var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBottombarContentBankActive = function SvgBottombarContentBankActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#bottombar-content-bank-active_svg__a)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M19.5 13.5h-15a.75.75 0 0 0-.75.75v4.5c0 .414.336.75.75.75h15a.75.75 0 0 0 .75-.75v-4.5a.75.75 0 0 0-.75-.75"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#bottombar-content-bank-active_svg__b)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M19.5 4.5h-15a.75.75 0 0 0-.75.75v4.5c0 .414.336.75.75.75h15a.75.75 0 0 0 .75-.75v-4.5a.75.75 0 0 0-.75-.75"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bottombar-content-bank-active_svg__c)",
    d: "M16.875 8.625a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bottombar-content-bank-active_svg__d)",
    d: "M16.875 17.625a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bottombar-content-bank-active_svg__a",
    x1: 12,
    x2: 12,
    y1: 13.5,
    y2: 19.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1967DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#001A9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bottombar-content-bank-active_svg__b",
    x1: 12,
    x2: 12,
    y1: 4.5,
    y2: 10.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1967DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#001A9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bottombar-content-bank-active_svg__c",
    x1: 16.875,
    x2: 16.875,
    y1: 6.375,
    y2: 8.625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1967DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#001A9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bottombar-content-bank-active_svg__d",
    x1: 16.875,
    x2: 16.875,
    y1: 15.375,
    y2: 17.625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1967DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#001A9F"
  })))));
};
export default SvgBottombarContentBankActive;